module.exports = __webpack_public_path__ + "static/media/Empty-img.e74c9437.png";